import { useEffect, useState } from "react";

import { getThumbnail } from "../../api/bangumihyoShosai";

import ImageModalModule from "./ImageModal.module.css";

type Props = {
  src: string;
  height?: string;
  width?: string;
  useModal?: boolean;
};

/**
 * サムネイルコンポーネント
 *
 * @param {*}
 * @return {*}
 */
const Thumbnail = ({
  src,
  height = "150px",
  width = "220px",
  useModal = false,
}: Props) => {
  const [thumbnail, setThumbnail] = useState<string>("");
  const [isNoImage, setIsNoImage] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (src) {
      const getThumbnailWrap = async () => {
        const result = await getThumbnail(src);
        setThumbnail(result.data);
      };

      getThumbnailWrap();
    } else {
      // サムネイルが無い場合、デフォルトのNoImage画像を表示
      const thumbnailUrl = `${process.env.PUBLIC_URL}/NoImage.png`;
      setThumbnail(thumbnailUrl);
      setIsNoImage(true);
    }
  }, [src]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div
      style={{
        minHeight: height,
        maxHeight: height,
        minWidth: width,
        maxWidth: width,
        position: "relative",
        backgroundColor: "rgba(0, 0, 0, 0.87)",
      }}
    >
      <img
        src={thumbnail}
        alt="Thumbnail"
        onClick={handleOpen}
        style={{
          width: "100%",
          height: "100%",
          objectFit: isNoImage ? "fill" : "contain",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          margin: "auto",
        }}
      />
      {useModal && isOpen && (
        <div
          onClick={handleClose}
          className={ImageModalModule["modal-overlay"]}
        >
          <div className={ImageModalModule["modal-content"]}>
            <img src={thumbnail} alt="画像" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Thumbnail;
